import React from 'react';
import { CTAButton } from './CTAButton';
import { Star, Shield, Zap } from 'lucide-react';
const CHECKOUT_URL = 'https://functional-trainer-system.impultienda.ar/checkout';
export function FinalCTA() {
  return <section className="py-10 px-4 bg-brand-petrol text-white" data-id="element-48">
      <div className="max-w-3xl mx-auto text-center" data-id="element-49">
        <p className="text-sm font-bold text-brand-gold uppercase tracking-wide mb-3" data-id="element-50">
          Eine letzte Chance
        </p>

        <p className="text-base sm:text-lg mb-5 leading-relaxed" data-id="element-51">
          Ihre Kunden verdienen mehr als Einheiten, die in letzter Minute
          geplant werden. Hören Sie auf, jede Woche Stunden mit dem Neuerstellen
          von Trainingsplänen und Kursstrukturen zu verschwenden. Geben Sie
          jedem Kunden eine professionelle, strukturierte Trainingserfahrung –
          und sich selbst das Planungssystem, das Sie sich von Ihrer ersten
          Trainingsstunde an gewünscht hätten.
        </p>

        <div className="bg-white/10 border-2 border-white/20 rounded-xl p-5 mb-6" data-id="element-52">
          <p className="text-base mb-2" data-id="element-53">
            🏋️ FUNCTIONAL TRAINER SYSTEM™ — 6-in-1 System + 5 Premium-Boni
          </p>
          <p className="text-xl line-through opacity-70 mb-1" data-id="element-54">97 €</p>
          <p className="text-4xl font-serif font-bold" data-id="element-55">Nur heute: 37 € EUR</p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="max-w-md mx-auto !bg-brand-gold !text-brand-graphite !border-white text-base sm:text-lg py-4 shadow-2xl ring-4 ring-brand-gold/40 hover:!bg-white hover:!text-brand-petrol hover:scale-[1.02]" data-id="element-56">
          🚀 JA! ICH MÖCHTE MEIN FUNCTIONAL TRAINER SYSTEM™
        </CTAButton>

        <div className="flex flex-wrap justify-center items-center gap-x-6 gap-y-2 text-sm mt-5 opacity-90" data-id="element-57">
          <div className="flex items-center gap-1" data-id="element-58">
            <Zap className="w-4 h-4" data-id="element-59" />
            <span data-id="element-60">Sofortiger Zugang — Lieferung per E-Mail</span>
          </div>
          <span className="hidden sm:inline" data-id="element-61">•</span>
          <div className="flex items-center gap-1" data-id="element-62">
            <Star className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-63" />
            <span data-id="element-64">4,9/5 – Verifizierte Bewertungen</span>
          </div>
          <span className="hidden sm:inline" data-id="element-65">•</span>
          <div className="flex items-center gap-1" data-id="element-66">
            <Shield className="w-4 h-4" data-id="element-67" />
            <span data-id="element-68">7-Tage-Garantie – Null Risiko</span>
          </div>
        </div>
      </div>
    </section>;
}